module.exports = __webpack_public_path__ + "img/制御工学3_1_4.418883b4.png";